import { Validation, ValueObject } from '@singularsystems/neo-core';

export default class DashboardNoteCriteria extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Dashboard Note Criteria";
    }
}